import { render, staticRenderFns } from "./Recommendations.vue?vue&type=template&id=841a5e98&scoped=true&"
import script from "./Recommendations.vue?vue&type=script&lang=ts&"
export * from "./Recommendations.vue?vue&type=script&lang=ts&"
import style0 from "./Recommendations.vue?vue&type=style&index=0&id=841a5e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841a5e98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VLayout,VRow})
